/**
 * @file     worker/consts.js - constants for use by the DistributiveWorker 
 * @author   Wes Garland, wes@distributive.network
 * @date     Jun 2025
 *
 * Note - this experimentally duplicates functionality in worker-constants.js - unify later.
 */
'use strict';

const { ConstantGroup } = require('dcp/utils');
const ns = 'distributive::';

exports.localStorageKeys = new ConstantGroup({
  worker: new ConstantGroup({
    id:                ns + 'worker.id',
    uncEarnObsolete:   ns + 'worker.unclaimedEarnings',
    uncEarnPrefix:     ns + 'worker.unclaimedEarnings.',
  }),
});

exports.friends = {
  supervisor: Symbol('friend access for supervisor'),
};

exports.workerFlags = new ConstantGroup({
  portalWorker: 1 << 0,
});
